import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "@/data/content";
import { Seo } from "@/components/Seo";

export default function Services() {
  return (
    <div>
      <Seo
        title="Insurance Options in New Zealand | Quantum Cover"
        description="Explore life, health, trauma, income protection, total permanent disability (TPD) and mortgage protection insurance, plus KiwiSaver. Clear, honest guidance to help you choose."
        path="/services"
      />
      <section className="bg-[#0B3D2E] text-white pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 max-w-4xl">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-emerald-400 mb-3">Our services</p>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight">The cover we can help with</h1>
          <p className="mt-5 text-lg text-slate-300 max-w-2xl">Take your time and read up on whatever's relevant to you. The more you know going in, the more useful your chat with an adviser will be.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {SERVICES.map((s) => {
            const Icon = Icons[s.icon] || Icons.Shield;
            return (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                data-testid={`services-list-${s.slug}`}
                className="group bg-white rounded-3xl border border-slate-200 p-8 shadow-[0_8px_30px_rgba(0,0,0,0.04)] hover:-translate-y-1 hover:shadow-[0_16px_50px_rgba(0,0,0,0.08)] transition-[transform,box-shadow] duration-300 flex gap-5"
              >
                <span className="grid place-items-center h-14 w-14 shrink-0 rounded-2xl bg-[#0B3D2E] text-emerald-400 group-hover:scale-105 transition-transform"><Icon size={26} /></span>
                <div className="min-w-0">
                  <h3 className="font-display text-xl font-semibold text-[#0B3D2E]">{s.name}</h3>
                  <p className="mt-1.5 text-slate-600 leading-relaxed">{s.what}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-emerald-700 group-hover:gap-2.5 transition-all">Learn more <ArrowRight size={15} /></span>
                </div>
              </Link>
            );
          })}
        </div>
      </section>
    </div>
  );
}
